import {
  Content,
  Sidebar as SidebarContainer,
  SidebarLayout,
} from "@counselpro/counselkit";
import { Outlet, useLoaderData } from "react-router-dom";

import AlertBanner from "@/components/alert-banner";
import Sidebar from "@/components/layout/sidebar";
import Resolver from "@/components/resolver";
import { useCustomerService } from "@/components/vendors";
import { STRIPE_CUSTOMER_PORTAL_URL } from "@/config";

export default function ApplicationLayout() {
  const { account } = useLoaderData();
  useCustomerService();

  return (
    <SidebarLayout>
      <SidebarContainer>
        <Sidebar />
      </SidebarContainer>
      <Content>
        <Resolver resolve={account}>
          {(account) => (
            <>
              {!account.active && (
                <AlertBanner
                  className="mb-5"
                  text="Your plan is inactive."
                  link={{
                    text: "Manage your subscription",
                    href: STRIPE_CUSTOMER_PORTAL_URL,
                  }}
                />
              )}
            </>
          )}
        </Resolver>

        <Outlet />
      </Content>
    </SidebarLayout>
  );
}
